export const initialNodes = [
    { id: 'start', type: 'start', position: { x: 50, y: 100 }, data: { label: 'start' } },
];
export const initialEdges = [
];
